import React from 'react';

import styled, { keyframes } from 'styled-components'

const Container = styled.div`
  padding: 10px 0 0 75px;
`;

const animate = keyframes`
  15% {
    opacity: 0.5;
    transform: translateY(-35%);
  }

  30% {
    opacity: 1;
    transform: translateY(0%);
  }
`;

const Dot = styled.span`
  animation: .75s ${animate} ease-in-out infinite;
  background-color: #5c5e69;
  border-radius: 100%;
  display: inline-block;
  height: 5px;
  margin-left: 4px;
  width: 5px;

  &:nth-of-type(2) {
    animation-delay: 0.15s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.25s;
  }
`;

const Typing: React.FC<{ name: string; }> = ({ name }) => (
  <Container>
    {`${name} `}
    <span style={{ fontStyle: 'italic' }}>
      está digitando
    </span>
    <Dot />
    <Dot />
    <Dot />
  </Container>
);

export default Typing;
